import {
  FilterOptions,
  PatientSubRole,
  PrescriptionStatus,
  ProductTypeFileds,
  ReactSelectOptionProp,
  RouteMap,
  Step,
} from '../interface/interface';
import homeIcon from '../assets/icons/home-icon.svg';
import medicinesIcon from '../assets/icons/medicines-icon.svg';
import shopIcon from '../assets/icons/shop-icon.svg';
import ordersIcon from '../assets/icons/orders-icon.svg';

// import mobileCart from '../assets/icons/cart-blue.svg';

export const route: RouteMap = {
  Admin: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
    {
      name: 'roles',
      href: 'javascript:void(0);',
      subNav: [
        { name: 'Internal User', href: '/internal-user', current: false },
        { name: 'Doctors', href: '/doctors', current: true },
        { name: 'Clinics', href: '/clinics', current: true },
      ],
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'new user',
    },
  ],

  Patients: [
    {
      name: 'Home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'My Care Hub',
      href: 'javascript:void(0);',
      subNav: [
        {
          name: 'medication information',
          href: '/prescriptions',
          current: false,
        },
        {
          name: 'dosing diaries',
          href: '/dosage-diary',
          current: false,
          specificAccessRole: PatientSubRole.InternalPatient,
        },
        { name: 'monthly limits', href: '/monthly-limit', current: false },
        { name: 'order history', href: '/orders', current: false },
      ],
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'My Care Hub',
    },
    {
      name: 'Shop non-script',
      href: '/non-script-range',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'shop',
    },
  ],

  Dispense_Tech: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],

  PLO: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],

  Pharmacist: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],
  Doctors: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patient/list',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
  ],
};

export const statuses = {
  Active: 'text-green-700 bg-green-50 ring-green-600/20',
  Expired: 'text-red-700 bg-red-50 ring-red-600/10',
  Withdraw: 'text-gray-600 bg-gray-50 ring-gray-500/10',
};

export const australianStates = [
  'Select',
  'New South Wales',
  'Victoria',
  'Queensland',
  'Tasmania',
  'South Australia',
  'Western Australia',
  'Northern Territory',
  'Australian Capital Territory',
];

export const publicUrls = [
  '/login',
  '/logout',
  '/reset-password',
  '/register',
  '/reset-password-mail',
  '/guest/shopping-products',
  '/guest/cart',
  '/guest/product',
];

export const title: ReactSelectOptionProp[] = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mx', value: 'Mx' },
];

export const genders: ReactSelectOptionProp[] = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Non-binary', value: 'non-binary' },
  { label: 'Gender-diverse', value: 'gender-diverse' },
  { label: 'Transgender', value: 'transgender' },
  { label: 'Different-identity', value: 'different-identity' },
  { label: 'Other', value: 'other' },
  { label: 'Unknown', value: 'unknown' },
];

export const roles: ReactSelectOptionProp[] = [
  { label: 'Admin', value: 'Admin' },
  { label: 'PLO (Patient Liaison Officer)', value: 'PLO' },
  { label: 'Dispense Tech', value: 'Dispense_Tech' },
  { label: 'Pharmacist', value: 'Pharmacist' },
];

export const addressTypeInter: ReactSelectOptionProp[] = [
  { label: 'Residential', value: 'residential' },
  { label: 'Business', value: 'business' },
  { label: 'Po', value: 'po' },
  { label: 'Other', value: 'other' },
  { label: 'Postal', value: 'postal' },
];

export const prescriptionStatus: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Cancelled', value: 'cancelled' },
];

export const filterPrescriptionStatus: ReactSelectOptionProp[] = [
  { label: 'Active', value: PrescriptionStatus.Active },
  { label: 'Dispensed', value: PrescriptionStatus.Dispensed },
  { label: 'Ceased', value: PrescriptionStatus.Ceased },
  { label: 'Cancelled', value: PrescriptionStatus.Cancelled },
  // { label: 'Completed', value: 'completed' },
  { label: 'Expired', value: PrescriptionStatus.Expired },
  { label: 'Stopped', value: PrescriptionStatus.Stopped },
];

export const prescrriptionStatusList: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Available', value: 'available' },
  { label: 'Exhausted', value: 'exhausted' },
  { label: 'Duplicate', value: 'duplicate' },
  { label: 'Expired', value: 'expired' },
  { label: 'Legacy', value: 'legacy' },
  { label: 'Completed', value: 'completed' },
  { label: 'Dispensed', value: 'dispensed' },
  { label: 'Disabled', value: 'disabled' },
];

export const InternalButNotAdmin = ['Dispense_Tech', 'PLO', 'Pharmacist'];

export const productStatusList: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const activeOrInActiveList: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const onboardedOrInvitedList: ReactSelectOptionProp[] = [
  { label: 'All Active', value: 'active' },
  { label: 'Invited', value: 'invited' },
  { label: 'Onboarded', value: 'onboarded' },
  { label: 'Not Onboarded', value: 'notOnboarded' },
  { label: 'Not Invited', value: 'notInvited' },
];

export const orderProductStatus = [
  { id: 0, name: 'Invalid', active: true, color_code: '#C12026' },
  { id: 1, name: 'Ordered', active: true, color_code: '#7989C2' },
  { id: 2, name: 'Dispensing', active: true, color_code: '#F3C6BA' },
  { id: 3, name: 'Ready for scan', active: true, color_code: '#F3F6FB' },
  { id: 4, name: 'Ready for shipping', active: true, color_code: '#BCC4E1' },
  { id: 5, name: 'Shipped', active: true, color_code: '#E39FC3' },
  { id: 6, name: 'Cancelled', active: true, color_code: '#9A1A1E' },
  { id: 7, name: 'Cancellation request', active: true, color_code: '#C5A2A4' },
  { id: 8, name: 'Paused', active: true, color_code: '#FEF2F3' },
];

export const specialCharacterRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

export const upperCaseRegex = /[A-Z]/;

export const numberCaseRegex = /[0-9]/;

export const productDefaultColors = [
  '#586CB3',
  '#DA7FAF',
  '#2CB57F',
  '#E78D75',
  '#A74C7C',
  '#E39FC3',
  '#EDA997',
  '#7989C2',
  '#F2D171',
  '#4C6495',
  '#F3C6BA',
  '#239166',
  '#BCC4E1',
  '#EEC142',
  '#EDBFD7',
  '#D5F0E5',
  '#E17052',
  '#F6DFEB',
  '#9BA7D1',
];

export const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*\W)(?!.*\s).{8,}$/;

export const renderStatusColor = (status: string, bg = true) => {
  switch (status) {
    case PrescriptionStatus.Active:
      if (bg) {
        return 'bg-secondary-green-100';
      }
      return 'bg-secondary-green-600';

    case PrescriptionStatus.Completed:
      if (bg) {
        return 'bg-secondary-green-100';
      }
      return 'bg-secondary-green-600';

    default:
      if (bg) {
        return 'bg-primary-red-100';
      }
      return 'bg-primary-red-600';
  }
};

export const filterByOptions = [
  { label: 'Date Type', value: '' },
  { label: 'Ordered Date', value: FilterOptions.CreatedDate },
  { label: 'Last Edited', value: FilterOptions.UpdatedDate },
];

export const userType = [
  { label: 'Internal', value: true },
  { label: 'External', value: false },
];

export const states = [
  { id: 1, name: 'New South Wales', abbriviation: 'NSW', country: { id: 1 } },
  { id: 2, name: 'Victoria', abbriviation: 'VIC', country: { id: 1 } },
  { id: 3, name: 'Queensland', abbriviation: 'QLD', country: { id: 1 } },
  { id: 4, name: 'Tasmania', abbriviation: 'TAS', country: { id: 1 } },
  { id: 5, name: 'South Australia', abbriviation: 'SA', country: { id: 1 } },
  { id: 6, name: 'Western Australia', abbriviation: 'WA', country: { id: 1 } },
  { id: 7, name: 'Northern Territory', abbriviation: 'NT', country: { id: 1 } },
  {
    id: 8,
    name: 'Australian Capital Territory',
    abbriviation: 'ACT',
    country: { id: 1 },
  },
];

export const creditCardProducts = [
  'Card Surcharge',
  'Credit Card Processing Fee',
];

export enum Messages {
  NON_ACTIVE_PRESCRIPTION_IN_CART = `The product prescription is invalid as it is no longer in active status. Please consider removing 
  the product or clearing the cart.`,
}

export const OutOfStockMessages = {
  QuantityZero: 'Out of Stock – Substitute Available.',
  OrderQuantityExceeds: (inventoryQuantity: number) =>
    `Product is almost out of stock, only ${inventoryQuantity} quantity available. 
     You can shop ${inventoryQuantity} or please contact our team for assistance on 1800 123 687.`,
  NoSubs: `Out of Stock.
  Please contact our team for assistance on 1800 123 687.`,
  NoDoctorApprovedSub:
    'Out of Stock, with no doctor approved substitutions. Please contact our team at 1800 123 687',
  OrderQuantitesExceededWithNoSubs: (
    inventoryQuantity: number,
  ) => `Product is Out of Stock, only ${inventoryQuantity} quantities available. You can shop ${inventoryQuantity} or
              Please contact our team for assistance 1800 123 687.`,
};

export const AusPostMax40Limit = 40;

export const AuspostTrackingURL = 'https://auspost.com.au/mypost/track/details';

export const ProductTypeLabelMapping = {
  [ProductTypeFileds.SCRIPT_RANGE]: 'Script Range',
  [ProductTypeFileds.NON_SCRIPT_RANGE]: 'Non Script Range',
  [ProductTypeFileds.DEVICEANDACCESSORIES]: 'Devices & Accessories',
  [ProductTypeFileds.BUNDLES]: 'Bundles',
};

export const patientUserTypeList: ReactSelectOptionProp[] = [
  { label: 'Patient', value: 'Patient' },
  { label: 'Prescription', value: 'Prescription' },
];

export const PatientTypeProps: ReactSelectOptionProp[] = [
  { label: 'External', value: 'external' },
  { label: 'Internal', value: 'internal' },
];

export const PatientStatusProps: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'InActive', value: 'inactive' },
];

export const RegisteredFilterProps: ReactSelectOptionProp[] = [
  { label: 'On', value: 'ON' },
  { label: 'Before', value: 'BEFORE' },
  { label: 'After', value: 'AFTER' },
  { label: 'Between', value: 'BETWEEN' },
];

export const steps: Step[] = [
  {
    id: 0,
    name: 'Select User Type and Email Template',
  },
  {
    id: 1,
    name: 'Select details',
  },
  {
    id: 2,
    name: 'Preview',
  },
];
export const SHOW_CUSTOMER_BANNER = false;

export const RemovedProductsCategory = [
  'CBD Capsules',
  'CBD Oil',
  'Grinder',
  'Softgel Capsules',
  'Wafers',
];

export const PrescriptionProps: ReactSelectOptionProp[] = [
  { label: 'Available', value: 'available' },
  { label: 'Active', value: 'active' },
  { label: 'InActivate', value: 'inactive' },
  { label: 'Exhausted', value: 'exhausted' },
  { label: 'Duplicate', value: 'duplicate' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Expired', value: 'expired' },
  { label: 'Legacy', value: 'legacy' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Completed', value: 'completed' },
  { label: 'Dispensed', value: 'dispensed' },
  { label: 'Disabled', value: 'disabled' },
  { label: 'Stopped', value: 'stopped' },
];

export const excludedProductListForPermissableProducts = [
  'Vapormed Mighty+ Medic',
  'Vapormed Mighty Medic',
];

export enum CartModalStorageKeys {
  PermanentlyDismissed = 'CART_MODAL_PERMANENTLY_DISMISSED',
  TemporarilyDismissed = 'CART_MODAL_TEMPORARILY_DISMISSED',
}

export const productNameToExclude = [
  'Card Surcharge',
  'Credit Card',
  'Card Surcharge v2',
];

export enum ProductBrands {
  ATLUS = 'Atlus',
}

export const DoctorTypeProps: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Internal', value: 'internal' },
  { label: 'External', value: 'external' },
];

export enum Pharmacy {
  MEDRELEAF = 'MedReleaf',
}

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const ZOOM_STEP = 0.2;
